export default "__VITE_ASSET__4bf9d248__"